export default __webpack_public_path__ + "static/media/notVisible.caa354bb.svg";